<template>
	<div class="col-12">
		<div class="card card-outline card-info">
			<ModalInstructions v-if="isModalVisible" @close="closeModal"></ModalInstructions>
			<div class="card-header">
				<h3 class="card-title">Llenado de evaluación</h3>
			</div>
			<div class="card-body w-full">
				<FillEvaluation :evaluation="thisEvaluation || []" v-if="!filled"></FillEvaluation>     
				<h3 v-else>Evaluación completada.</h3> 

				<div v-if="autoEvaluation.length > 0" class="details-table">
					<table>
					<thead>
						<tr>
						<th>Competencia</th>
						<th>Calificación</th>
						</tr>
					</thead>
					<tbody>
						<tr
						v-for="competency in autoEvaluation[0].competency_scores"
						:key="competency.competency_name"
						>
						<td>{{ competency.competency_name }}</td>
						<td>{{ formatScore(competency.average_score) }} Pts</td>
						</tr>
					</tbody>
					</table>
				</div>			

			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import request from '../../services/request'
import FillEvaluation from '../../component/evaluations/FillEvaluation.vue';
import ModalInstructions from '../../component/evaluations/ModalInstructions.vue';

export default {
	name: "auto-evaluation",
	components: {
		FillEvaluation,
		ModalInstructions
	},
	data() {
		return {
			evaluations: [],
			autoEvaluation: [],
			isModalVisible: false,
			filled : false,
		}
	},
	async mounted() {
		this.setHeaderTitle('Auto Evaluación');
		await this.evaluationsRequest()
		await this.filledAutoEvaluation()
	},
	computed: { 
		thisEvaluation() {
			let evaluation = [];
			if (this.evaluations && this.evaluations.data) {					
				evaluation = this.evaluations.data[0];
			}
			return evaluation;
		},
	},
	created() {
		Event.$on("event-load-profiles", () => {
			this.list();
		});
	},
	methods: {
        async evaluationsRequest() {
			let service = request;
			let _endpoint = '/my-evaluation';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					this.evaluations = data;
				}
			} catch (error) {
				console.log(error);
			}
		},		
		formatScore(score) {
			return score !== null ? score.toFixed(2) : "N/A";
		},
		async filledAutoEvaluation() {
			let service = request;
			let _endpoint = '/evaluations/mine';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					this.filled = data.data.exists;
					if (!data.data.exists) {
						this.isModalVisible = true;
					}
					this.autoEvaluation = data.data.autoevaluation || []
				}
			} catch (error) {
				console.log(error);
			}
		},
		openModal() {
		this.isModalVisible = true; 
		},
		closeModal() {
		this.isModalVisible = false;
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
		})
	}
}
</script>

<style scoped>
.card-body{
	width: 100%;
	max-height: 75vh;
    overflow-y: overlay;
}
/* General */
* {
  scrollbar-color: #1d4745 #ffffff; /* Color del thumb y del fondo */
  scrollbar-width: thin; /* Ancho del scroll reducido */
}

/* Webkit */
::-webkit-scrollbar {
  width: 12px; /* Ancho del scroll vertical */
  height: 12px; /* Altura del scroll horizontal */
}

::-webkit-scrollbar-track {
  background: #ffffff; /* Fondo blanco del scroll */
  border-radius: 10px; /* Bordes redondeados del track */
  margin: 2px; /* Espaciado para evitar que el thumb toque los bordes */
}

::-webkit-scrollbar-thumb {
  background: #1d4745; /* Color del thumb */
  border-radius: 10px; /* Bordes redondeados del thumb */
  border: 2px solid #ffffff; /* Espaciado entre el thumb y el track */
}

::-webkit-scrollbar-thumb:hover {
  background: #14534f; /* Color más oscuro al pasar el mouse */
}


.details-table table {
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
}

.details-table th,
.details-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}
.td-baseline{
  vertical-align: baseline;
}

</style>
